/*
 * Lib Module Toggles
 */

Lib.Toggle = (function() {
    let self = {};

    $(Lib).on('document.ready', function() {

        self.bindToggles();

        $(document).on('click', '.collapsible .collapsible-toggle', function(e) {
            e.preventDefault();

            // Get the collapse wrapper
            let collapseWrapper = $(this).closest('.collapsible');
            let collapseContent = collapseWrapper.find('.collapsible-content');
            let isCollapsed = collapseWrapper.hasClass('collapsed');

            if (isCollapsed) {
                $(this).find('.is-icon').addClass('rotate-180');
                collapseContent.slideDown(250, function() {
                    collapseWrapper.removeClass('collapsed');
                });
            } else {
                $(this).find('.is-icon').removeClass('rotate-180');
                collapseContent.slideUp(250, function() {
                    collapseWrapper.addClass('collapsed');
                });
            }
        });

        $(document).on('click', '[data-toggle-class]', function(e) {
            e.preventDefault();
            let toggleClass = $(this).data('toggle-class');
            $.each(toggleClass, function(target, classes) {
                $(target).toggleClass(classes);
            });
        });

        // Navigation
        $(document).on('click', '.nav-toggle', function() {
            if ($(this).hasClass('nav-toggled')) {
                $('.sidebar-left').removeClass('open');
                $(this).removeClass('nav-toggled');
                $('.clickmask').removeClass('shady level-3').hide();
                $('body').removeClass('overflow-hidden');
            } else {
                $('body').addClass('overflow-hidden');
                $('.sidebar-left').addClass('open');
                $(this).addClass('nav-toggled');
                $('.clickmask').addClass('shady level-3').show();
            }
        });

        $(Lib).on('orientation.change', function() {
            $('.clickmask').trigger('click');
        });

        // Mobile main menu
        $(document).on('click', '.sidebar-left .button', function() {
            if ($(this).hasClass('open-main-menu')) {
                $(this).removeClass('open-main-menu');
                $('.sidebar-left ul.main-menu-side').removeClass('open');
            } else {
                $(this).addClass('open-main-menu');
                $('.sidebar-left ul.main-menu-side').addClass('open');
            }
        });

        // Dropdown, click
        $(document).on('click', '.dropdown-menu>a, .dropdown-menu>button', function() {
            if ($(this).parent().find('.dropdown-list').length) {
                $(this).parent().addClass('dropdown-active');
                $('.clickmask').show();
            }
        });

        if (!Lib.BrowserDetect.isMobile()) {

            let hoverTimeout;
            $(document).on('mouseenter', '.dropdown-menu>a, .dropdown-menu>button', function() {
                clearTimeout(hoverTimeout);
                if ($(this).parent().find('.dropdown-list').length) {
                    $(this).parent().addClass('dropdown-active');
                    $('.clickmask').show();
                }
            });

            $(document).on('mousemove', '.dropdown-menu', function() {
                if (!$(this).parent().hasClass('fab-container')) {
                    clearTimeout(hoverTimeout);
                }
            });

            $(document).on('mouseout', '.dropdown-menu', function(e) {
                if (!$(this).parent().hasClass('fab-container')) {
                    let $self = $(this);

                    hoverTimeout = setTimeout(function() {
                        $self.removeClass('dropdown-active');
                        $('.clickmask').hide();
                    }, 750);
                }
            });

            $(document).on('mousemove', '.fab-container', function() {
                clearTimeout(hoverTimeout);
            });

            $(document).on('mouseout', '.fab-container', function() {
                let $self = $(this);
                hoverTimeout = setTimeout(function() {
                    $self.find('.dropdown-menu').removeClass('dropdown-active');
                    $('.clickmask').hide();
                }, 750);
            });
        }

        $(document).on('click', '.dropdown-active .dropdown-list li', function() {
            $('.dropdown-active').removeClass('dropdown-active');
            $('.clickmask').hide();
        });

        $(document).on('click touchstart', 'div.clickmask', function(e) {
            e.stopPropagation();
            e.preventDefault();
            $('.dropdown-active').removeClass('dropdown-active');
            $('.sidebar-left').removeClass('open');
            $('.nav-toggle').removeClass('nav-toggled');
            $('.sidebar-left .sidebar-level-1 .button').removeClass('open-main-menu');
            $('.card.tab-menu-open').removeClass('tab-menu-open');
            $('.card').find('.fab-container').removeClass('animated hinge');
            $('body').removeClass('overflow-hidden');
            $(this).removeClass('shady level-1 level-2 level-3').hide();
        });
    });

    /**
     * Bind default toggles
     */
    self.bindToggles = function(targetElements) {

        targetElements = targetElements || $('[data-toggle]');

        if (targetElements instanceof $) {

            // Loop through them
            targetElements.each(function() {

                // For use later
                let target = $(this);

                // Get all toggle options
                let toggleOptions = $(this).data('toggle');

                if (toggleOptions) {
                    // Get the source element
                    let source = $(toggleOptions.source);

                    // If we have a source element
                    if (source.length) {

                        let state = target.attr('data-toggle-state');
                        if (typeof state === typeof undefined || state === false) {
                            target.attr('data-toggle-state', Lib.Hash.get(toggleOptions, 'initial-state', 'show'));
                        }

                        // Loop through source elements
                        source.each(function() {

                            // Used for later
                            let currentSource = $(this);

                            // See what tag the source is
                            let sourceTag = currentSource.prop('tagName').toLowerCase();
                            switch (sourceTag) {
                                case 'input':
                                    self.bindInput(target, currentSource, toggleOptions);
                                    break;
                                case 'textarea':
                                    self.bindTextarea(target, currentSource, toggleOptions);
                                    break;
                                case 'select':
                                    self.bindSelect(target, currentSource, toggleOptions);
                                    break;
                            }
                        });
                    } else {
                        Lib.Debug.warn('Trying to bind a toggle event but cannot find toggle source, ' + toggleOptions.source);
                    }
                }
            });
        }
    };

    self.bindSelect = function(target, source, toggleOptions) {
        source.on('change', function() {
            self.toggleOnValue($(this).val(), toggleOptions, target);
        }).triggerHandler('change');
    };

    self.bindInput = function(target, source, toggleOptions) {
        let inputType = source.prop('type');
        if (inputType) {
            switch (inputType) {
                case 'hidden':

                    // Only bind the toggle on hidden fields if its NOT a hidden field for a checkbox
                    // noinspection JSJQueryEfficiency
                    let checkboxesForHiddenInput = $(`:checkbox[name="${source.attr('name')}"]`);
                    if (checkboxesForHiddenInput.length === 0) {
                        source.on('change', function() {
                            self.toggleOnValue($(this).attr('value'), toggleOptions, target);
                        }).triggerHandler('change', {autosubmit: false});
                    }

                    break;
                case 'checkbox':

                    // noinspection JSJQueryEfficiency
                    let allCheckboxesWithSameName = $(`:checkbox[name="${source.attr('name')}"]`);
                    if (allCheckboxesWithSameName.length > 1) {

                        allCheckboxesWithSameName.on('change', function() {

                            let selectedValues = [];
                            allCheckboxesWithSameName.each(function() {
                                if ($(this).is(':checked')) {
                                    selectedValues.push($(this).attr('value'));
                                }
                            });

                            self.toggleOnValue(selectedValues, toggleOptions, target);

                        });

                        let selectedValues = [];
                        allCheckboxesWithSameName.each(function() {
                            if ($(this).is(':checked')) {
                                selectedValues.push($(this).attr('value'));
                            }
                        });

                        self.toggleOnValue(selectedValues, toggleOptions, target);
                        
                    } else {

                        source.on('change', function() {

                            let checked = $(this).is(':checked');

                            let val = checked ? $(this).attr('value') : 'non-existent';

                            self.toggleOnValue(val, toggleOptions, target, $(this).attr('id'));

                        }).triggerHandler('change', {autosubmit: false});

                    }

                    break;
                case 'radio':

                    source.on('change', function() {

                        let val = $(this).is(':checked') ? $(this).attr('value') : 'non-existent';
                        self.toggleOnValue(val, toggleOptions, target);

                    }).filter(':checked').triggerHandler('change', {autosubmit: false});

                    break;
                case 'text':

                    source.on('keyup', function() {
                        self.toggleOnValue($(this).val(), toggleOptions, target);
                    }).triggerHandler('keyup', {autosubmit: false});

                    break;
            }
        }
    };

    self.bindTextarea = function(target, source, toggleOptions) {
        source.on('keyup', function() {
            self.toggleOnValue($(this).val(), toggleOptions, target);
        }).triggerHandler('keyup');
    };

    self.toggleOnValue = function(value, toggleOptions, target) {

        let toggleOnValues, not = false;
        if ('source-value' in toggleOptions) {
            toggleOnValues = toggleOptions['source-value'];
        } else if ('source-not-value' in toggleOptions) {
            toggleOnValues = toggleOptions['source-not-value'];
            not = true;
        } else {
            Lib.Debug.warn('Couldnt determine what source value to use in toggle, provide source-value or source-not-value in data-toggle');
            return false;
        }

        if (!$.isArray(toggleOnValues)) {
            toggleOnValues = [toggleOnValues];
        }

        if (!$.isArray(value)) {
            value = [value];
        }

        // Reset, sort and force all elements to be strings
        toggleOnValues = toggleOnValues.slice().sort().map(String);
        value = value.slice().sort().map(String);

        // Check if the value selected in the input includes any of the toggle values
        let selectedValueExistsInToggleValues = toggleOnValues.filter(function(toggleOnValue) {
            return value.includes(toggleOnValue);
        }).length > 0;

        let showTarget = selectedValueExistsInToggleValues ? !not : not;

        if (showTarget) {
            target.attr('data-toggle-state', 'show');

            let textareas = target.find('textarea');
            if (textareas.length) {
                Lib.Textarea.updateAutosize(textareas);
            }
        } else {

            target.attr('data-toggle-state', 'hide');

            if (Lib.Hash.get(toggleOptions, 'reset-fields-on-hide')) {
                Lib.Form.resetFieldsInContainer(target);
            }

        }

    };

    return self;

})();
